// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Auth
import { AuthGuard, PermissionGuard, RolesGuard } from './core/auth';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
import { FaqComponent } from './views/pages/faq/faq.component';
import { ProfileComponent } from './views/pages/profile/profile.component';
import { DynamicPageViewComponent } from './views/pages/page-view/dynamic-page-view.component';
import { DashboardComponent } from './views/pages/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
  },

  {
    path: 'settings',
    canActivate: [AuthGuard, RolesGuard],
    loadChildren: () => import('./views/pages/admin/admin.module').then((m) => m.AdminModule),
    data: {
      roles: ['admin'],
    },
  },

  {
    path: 'error/403',
    component: ErrorPageComponent,

    data: {
      type: 'error-v6',
      code: 403,
      title: '403... Доступ запрещён',
      titleTranslate: 'ERRORS.403.TITLE',
      desc: 'Похоже, вы не имеете права на просмотр этой страницы.<br> Пожалуйста, обратитесь к администратору',
      descTranslate: 'ERRORS.403.DESC',
    },
  },

  {
    path: 'error/404',
    component: ErrorPageComponent,
    data: {
      type: 'error-v1',
      code: 404,
      desc: 'Запрашиваемая страница не найдена',
      descTranslate: 'ERRORS.404.DESC',
    },
  },

  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },

      {
        path: 'profile',
        component: ProfileComponent,
      },

      {
        path: 'faq',
        component: FaqComponent,
      },

      {
        path: ':page',
        canActivate: [PermissionGuard],
        component: DynamicPageViewComponent,
      },

      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },

      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() {}
}
